<customers-menu (onChangeCustomerType)="changeCustomerType($event)" (outputDownload)="downloadExcelFile()" (onReload)="onReload()" [currentType]="currentType"></customers-menu>
<div class="container-tab-lists">
  <div class="inner-tcontainer-tab">
    <div class="tab-body">
      <div class="tab-content">
        <mat-tab-group mat-stretch-tabs="false" #tabGroup (selectedTabChange)="changeCustomerType($event); defaults.updateComponentTab($event.tab.textLabel)">
          <!--Messages-->
          <mat-tab label="Customers">
            <div>
              <customeritem #customerItemComponent></customeritem>
            </div>
          </mat-tab>
          @if (defaults.stage !== 3) {
            <mat-tab label="Facilities Managers">
              <div>
                <customerfacilitymanager #managerComponent></customerfacilitymanager>
              </div>
            </mat-tab>
          }
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>
